import React from "react";
import { Container } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./PolicyPages.css";
import JobSeekerNavbar from "../Pages/Navbar/Navbar";
import EmployerNavbar from "../Pages/Navbar/EmployerNavbar";
import EmployeeNavbar from "../Pages/Navbar/JobSeekerNavbar";
import AgencyNavbar from "../Pages/Navbar/AgencyNavbar";
import AdminNavbar from "../Pages/Navbar/AdminNavbar";
import Footer from "../Footer/Footer"

const user = JSON.parse(localStorage.getItem("user")) || {};

// Determine which Navbar to show
const renderNavbar = () => {
  if (user.user_type === "employer") {
    return <EmployerNavbar />;
  } else if (user.user_type === "job seeker") {
    return <EmployeeNavbar />;
  } else if (user.user_type === "agency") {
    return <AgencyNavbar />;
  } else if (user.user_type === "admin") {
    return <AdminNavbar />;
  } else {
    return <JobSeekerNavbar />;
  }
};

function PrivacyPolicy() {
  const { i18n } = useTranslation();
  const isArabic = i18n.language === 'ar';

  return (
    <>
      {renderNavbar()}
      <div className="policy-section py-5 mt-5">
        <Container>
          {isArabic ? (
            <>
              <h1 className="mb-4 text-center fw-bold">
                سياسة الخصوصية –{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>
              </h1>

              <p>
                في موقع{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>{" "}
                ("الموقع الإلكتروني" أو "البوابة" أو "نحن")، تعتبر خصوصيتك أمراً بالغ الأهمية بالنسبة لنا. توضح سياسة الخصوصية هذه كيفية جمع معلوماتك الشخصية واستخدامها وحمايتها عند الوصول إلى خدماتنا أو استخدامها.
              </p>

              <div className="mt-4">
                <h4>1. المعلومات التي نجمعها</h4>
                <p>قد نجمع الأنواع التالية من المعلومات:</p>
                <ul>
                  <li>
                    <strong>الباحثون عن عمل:</strong> الاسم، البريد الإلكتروني، رقم الهاتف، السيرة الذاتية، وتفاصيل الملف الشخصي المهني.
                  </li>
                  <li>
                    <strong>أصحاب العمل ومكاتب الاستقدام:</strong> اسم الشركة، تفاصيل الاتصال، الوظائف المنشورة، وتفاصيل الاشتراك.
                  </li>
                  <li>
                    <strong>البيانات الفنية:</strong> عنوان IP، نوع المتصفح، معلومات الجهاز، وسجلات الاستخدام.
                  </li>
                </ul>

                <h4>2. كيف نستخدم معلوماتك</h4>
                <p>تُستخدم معلوماتك لـ:</p>
                <ul>
                  <li>
                    تقديم خدمات بوابة الوظائف للباحثين عن عمل وأصحاب العمل ومكاتب الاستقدام.
                  </li>
                  <li>
                    تحسين وظائف الموقع وأدائه وتجربة المستخدم.
                  </li>
                  <li>
                    إرسال الإشعارات أو التحديثات أو العروض الترويجية (إذا اخترت الاشتراك فيها).
                  </li>
                  <li>
                    تسهيل التواصل بين الباحثين عن عمل وأصحاب العمل ومكاتب الاستقدام.
                  </li>
                </ul>

                <h4>3. مشاركة البيانات</h4>
                <p>نحن لا نبيع أو نتاجر بمعلوماتك الشخصية. قد تتم مشاركة البيانات فقط مع:</p>
                <ul>
                  <li>
                    أصحاب العمل ومكاتب الاستقدام عندما يتقدم الباحثون عن عمل للوظائف.
                  </li>
                  <li>مقدمو الخدمات الذين يساعدون في تشغيل المنصة.</li>
                  <li>
                    السلطات القانونية إذا تطلب القانون ذلك للامتثال للأنظمة واللوائح.
                  </li>
                </ul>

                <h4>4. العرض العام للمعلومات</h4>
                <ul>
                  <li>
                    قد تكون تفاصيل الاتصال الخاصة بالباحثين عن عمل وأصحاب العمل ومكاتب الاستقدام مرئية للمستخدمين والزوار الآخرين للموقع الإلكتروني لأغراض التوظيف.
                  </li>
                  <li>أنت مسؤول عن المعلومات التي تختار مشاركتها علناً.</li>
                </ul>

                <h4>5. أمن البيانات</h4>
                <ul>
                  <li>
                    نحن نطبق تدابير فنية وتنظيمية معقولة لحماية بياناتك.
                  </li>
                  <li>
                    لا يوجد نظام آمن تماماً؛ وبالتالي لا يمكننا ضمان الحماية المطلقة.
                  </li>
                </ul>

                <h4>6. ملفات تعريف الارتباط (Cookies)</h4>
                <ul>
                  <li>
                    نستخدم ملفات تعريف الارتباط لتحسين تجربة التصفح لديك ووظائف الموقع الإلكتروني.
                  </li>
                  <li>
                    يمكنك تعطيل ملفات تعريف الارتباط في متصفحك، ولكن قد لا تعمل بعض الميزات بشكل صحيح.
                  </li>
                </ul>

                <h4>7. حقوقك</h4>
                <p>كمستخدم، يمكنك:</p>
                <ul>
                  <li>الوصول إلى معلوماتك الشخصية أو تصحيحها أو تحديثها.</li>
                  <li>طلب حذف حسابك والبيانات المرتبطة به.</li>
                  <li>إلغاء الاشتراك في الاتصالات الترويجية في أي وقت.</li>
                </ul>

                <h4>8. تحديثات السياسة</h4>
                <p>
                  قد يقوم موقع{" "}
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  بتحديث سياسة الخصوصية هذه حسب الحاجة. وتصبح التغييرات سارية المفعول بمجرد نشرها على الموقع الإلكتروني. ويعتبر استخدامك المستمر للموقع قبولاً للسياسة المحدثة.
                </p>

                <h4>9. اتصل بنا</h4>
                <p>
                  للاستفسارات المتعلقة بالخصوصية، يرجى الاتصال بنا عبر: <br />
                  📧 البريد الإلكتروني:{" "}
                  <a href="mailto:support@gulfworker.net">support@gulfworker.net</a>
                </p>
              </div>
            </>
          ) : (
            <>
              <h1 className="mb-4 text-center fw-bold">
                Privacy Policy –{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>
              </h1>

              {/* <p className="text-muted text-center">Effective Date: [Insert Date]</p>
              <p className="text-muted text-center">Last Updated: [Insert Date]</p> */}

              <p>
                At{" "}
                <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                  Gulfworker.net
                </a>{" "}
                (“Website,” “Portal,” “We,” or “Us”), your privacy is important.
                This Privacy Policy explains how we collect, use, and protect your
                personal information when you access or use our services.
              </p>

              <div className="mt-4">
                <h4>1. Information We Collect</h4>
                <p>We may collect the following types of information:</p>
                <ul>
                  <li>
                    <strong>Jobseekers:</strong> Name, email, phone number, CV, and
                    professional profile details.
                  </li>
                  <li>
                    <strong>Employers and Manpower Agencies:</strong> Company name,
                    contact details, job postings, and subscription details.
                  </li>
                  <li>
                    <strong>Technical Data:</strong> IP address, browser type,
                    device information, and usage logs.
                  </li>
                </ul>

                <h4>2. How We Use Your Information</h4>
                <p>Your information is used to:</p>
                <ul>
                  <li>
                    Provide job portal services to Jobseekers, Employers, and
                    Agencies.
                  </li>
                  <li>
                    Improve the Website’s functionality, performance, and user
                    experience.
                  </li>
                  <li>
                    Send notifications, updates, or promotional offers (if you opt
                    in).
                  </li>
                  <li>
                    Facilitate communication between Jobseekers, Employers, and
                    Manpower Agencies.
                  </li>
                </ul>

                <h4>3. Data Sharing</h4>
                <p>We do not sell or trade your personal information. Data may only be shared with:</p>
                <ul>
                  <li>
                    Employers and Manpower Agencies when Jobseekers apply for jobs.
                  </li>
                  <li>Service providers who assist in operating the platform.</li>
                  <li>
                    Legal authorities if required by law to comply with regulations.
                  </li>
                </ul>

                <h4>4. Public Display of Information</h4>
                <ul>
                  <li>
                    Contact details of Jobseekers, Employers, and Manpower Agencies
                    may be visible to other users and visitors of the Website for
                    recruitment purposes.
                  </li>
                  <li>You are responsible for the information you choose to share publicly.</li>
                </ul>

                <h4>5. Data Security</h4>
                <ul>
                  <li>
                    We implement reasonable technical and organizational measures to
                    protect your data.
                  </li>
                  <li>
                    No system is completely secure; we cannot guarantee absolute
                    protection.
                  </li>
                </ul>

                <h4>6. Cookies</h4>
                <ul>
                  <li>
                    We use cookies to enhance your browsing experience and website
                    functionality.
                  </li>
                  <li>
                    You may disable cookies in your browser, but some features may
                    not work correctly.
                  </li>
                </ul>

                <h4>7. Your Rights</h4>
                <p>As a user, you may:</p>
                <ul>
                  <li>Access, correct, or update your personal information.</li>
                  <li>Request deletion of your account and associated data.</li>
                  <li>Opt out of promotional communications at any time.</li>
                </ul>

                <h4>8. Policy Updates</h4>
                <p>
                  <a href="https://gulfworker.net" target="_blank" rel="noopener noreferrer">
                    Gulfworker.net
                  </a>{" "}
                  may update this Privacy Policy as needed. Changes become effective
                  once published on the Website. Continued use of the Website
                  constitutes acceptance of the updated Policy.
                </p>

                <h4>9. Contact Us</h4>
                <p>
                  For privacy-related inquiries, please contact: <br />
                  📧 Email:{" "}
                  <a href="mailto:support@gulfworker.net">support@gulfworker.net</a>
                </p>
              </div>
            </>
          )}
        </Container>
      </div>
      <Footer />
    </>
  );
}

export default PrivacyPolicy;
